export const TWO_FA_METHOD = {
  NOTIFICATION: 'NOTIFICATION',
  SECURITY_QUESTION: 'QUESTION',
};
